import moment from 'moment';
import { now } from 'works/legacy/lib/date-helper';
import { difference } from 'lodash';
import { BillingCardType } from '@institutions/graphql';

export function getRateCardsByComputedStatus(allCards: BillingCardType[] = []) {
  const activeCardIndex = allCards.findIndex(
    (card) => moment(card.effectiveDate) <= now()
  );
  const activeCard = allCards[activeCardIndex];

  const futureCards =
    activeCardIndex === -1 ? allCards : allCards.slice(0, activeCardIndex);

  const upcomingCards: BillingCardType[] = [];

  futureCards.forEach((card) => {
    if (
      upcomingCards.length === 0 ||
      moment(card.effectiveDate) <= moment(upcomingCards[0].effectiveDate)
    ) {
      upcomingCards.unshift(card);
    }
  });

  const expiredCards = difference(allCards, [activeCard, ...upcomingCards]);

  const inEffectCards = activeCard
    ? [activeCard, ...upcomingCards]
    : upcomingCards;

  return { expiredCards, inEffectCards };
}
